<template>
  <div class="container">
    <div class="row">
      <div class="col-md-5 mx-auto rounded-3 login-container">
        <div class="alert alert-warning" role="alert">
          <h6>{{ $t("login.onlyOnwer") }}</h6>
          <a href="https://www.maika.coffee">{{ $t("login.backToMaika") }}</a>
        </div>
        <div id="first">
          <div class="myform form ">
            <div class="logo mb-3">
              <div class="col-md-12 text-center">
                <h1>{{ $t("login.login") }}</h1>
              </div>
            </div>
            <hr />
            <div
              class="alert alert-danger"
              role="alert"
              v-if="errorMessage != ''"
            >
              {{ $t(errorMessage) }}
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1">{{ $t("login.email") }}</label>
              <input
                type="email"
                name="email"
                class="form-control"
                id="email"
                aria-describedby="emailHelp"
                placeholder="Enter email"
                v-model="email"
              />
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1">{{ $t("login.password") }}</label>
              <input
                type="password"
                name="password"
                id="password"
                class="form-control"
                aria-describedby="emailHelp"
                placeholder="Enter Password"
                v-model="password"
              />
            </div>
            <div class="form-group">
              <p class="text-center">
                <!-- By signing up you accept our <a href="#">Terms Of Use</a> -->
              </p>
            </div>
            <div class="col-md-12 text-center ">
              <button
                :disabled="isConnecting"
                @click="login"
                type="submit"
                class=" btn btn-block mybtn btn-primary tx-tfm login-button"
              >
                {{ $t("login.login") }}
              </button>
            </div>
          </div>
          <!-- <a href="">{{ $t("login.forgotPassword") }}</a> -->
        </div>
        <div class="alert alert-primary" role="alert">
          {{ $t("login.newToApp") }}
          <router-link to="/signup">{{ $t("login.signup") }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import router from "@/router";
import OwnerService from "@/services/OwnerService";
const ownerService = new OwnerService();

export default defineComponent({
  name: "Login",
  props: {},
  setup(props) {
    console.log("coucou", props);
  },
  methods: {
    // TODO FIRST
    // put in service
    //display error message on view
    async login() {
      this.errorMessage = "";
      this.isConnecting = true;
      console.log("try to login", this.email);
      if (this.email == "" || this.password == "") {
        this.errorMessage = this.$t("login.fieldsMandatory");
        this.isConnecting = false;
        return false;
      }
      if (this.password.length < 8) {
        this.errorMessage = this.$t("login.passwordShort");
        console.log("pwd too short");
        this.isConnecting = false;
        return false;
      }
      const connectionAnswer = await ownerService.connectOwner(
        this.email,
        this.password
      );
      console.log("connectionAnswer", connectionAnswer);
      if (connectionAnswer.success) {
        window.location.reload();
        // router.replace("/");
        //redirect to /home
      } else {
        this.isConnecting = false;
        this.errorMessage = connectionAnswer.message;
      }
    },
  },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      isConnecting: false,
    };
  },
});
</script>

<style></style>
